'use es6';

import PropTypes from 'prop-types';
import { getColors } from 'reporting-ui-components/reports/utils/colors/chartColors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DataWellChartIcon = ({
  colorSeriesType = 'DEFAULT',
  size = 25
}) => {
  const colors = getColors(colorSeriesType, [0, 1]);
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsxs("svg", {
      width: size,
      height: size,
      viewBox: "0 0 80 80",
      children: [/*#__PURE__*/_jsx("circle", {
        fill: "none",
        stroke: colors[0],
        strokeWidth: "6",
        cx: "39",
        cy: "39",
        r: "36"
      }), /*#__PURE__*/_jsx("path", {
        fill: colors[1],
        d: "M37.4,56.7V34.9H29v-5.1c1.2,0,2.3-0.1,3.4-0.3c1.1-0.2,2.1-0.6,3-1.1s1.6-1.2,2.2-2.1c0.6-0.9,1-1.9,1.2-3.2h5.4v33.6H37.4z"
      })]
    })
  });
};
DataWellChartIcon.propTypes = {
  size: PropTypes.number,
  colorSeriesType: PropTypes.string
};
export default DataWellChartIcon;